<script lang="ts">
  import { default as InvoiceDetailIndex } from "@retailer/svelte/Payments/InvoiceDetailIndex.svelte";
  import { params } from "@roxi/routify";

</script>

<InvoiceDetailIndex invoiceId={$params.invoiceId} />
